var isKeyboardEvent = function isKeyboardEvent(event) {
  return event.key !== undefined;
};

export default isKeyboardEvent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/utils/dist/esm/isKeyboardEvent/index.js
// module id = 1045
// module chunks = 12